export const PRACTICE_SWITCH_COLLAPSED_HEIGHT = 40;
export const PRACTICE_SWITCH_EXPANDED_HEIGHT = 56;
